import React from 'react';

const FormTitle = ({ 
  config, 
  componentShowingState, 
  extra_title, 
  localDisabledReason,
  showLongDescriptions,
  handleToggleLongDescriptions
}) => {
  const STATE_NEW = 'new';
  const STATE_EDIT = 'edit';
  const STATE_COPY_FROM_SYSTEM = 'copy_from_system';

  const toggleDescriptionsControl = () => {
    return (
      <label className="switch-small" title={t('quote_builder.toggle_summaries')}>
        <input type="checkbox" className="pref" checked={showLongDescriptions} onChange={handleToggleLongDescriptions}/>
        <span className="slider-small"></span>
      </label>);
  }

  // The badge tells the user at a glance that the add/edit form defines a UserUnitPrice -- a price
  // form, not an "add a machine" form. It shows only on the create/edit form title itself
  // (new_title / edit_title), never on a section header (config.title, e.g. "Baskı" on /mcc), and
  // never on the attribute editors (which submit to user_unit_price_attributes_with_properties
  // rather than user_unit_prices).
  const createPath = config.submit && config.submit.create_path;
  const isUnitPriceForm = createPath == undefined || createPath.includes('/user_unit_prices/');
  const showingFormTitle =
    ((componentShowingState == STATE_NEW || componentShowingState == STATE_COPY_FROM_SYSTEM) && config.new_title != undefined) ||
    (componentShowingState == STATE_EDIT && config.edit_title != undefined);

  return (config.new_title != undefined || config.edit_title != undefined || config.title != undefined) && (
    <tr>
      <th colSpan="2">
        {isUnitPriceForm && showingFormTitle && (
          <span className="q-unit-price-badge">
            <i className="fa fa-tag" aria-hidden="true"></i> {t('quote_builder.unit_price_form_badge')}
          </span>)}
        {config.new_title != undefined && componentShowingState == STATE_NEW && t(config.new_title) }
        {config.new_title != undefined && componentShowingState == STATE_COPY_FROM_SYSTEM && t(config.new_title) }
        {config.edit_title != undefined && componentShowingState == STATE_EDIT && t(config.edit_title)}
        {config.title != undefined && (<span className="q-section-title">{t(config.title)}</span>) } {false && config.title != undefined && extra_title != undefined && ` (${t(extra_title)})` }
        {config.toggle_long_descriptions && <div className="float-right"> {toggleDescriptionsControl()} </div>}

        {localDisabledReason && (<span className="float-right"> <small className="q-read-only-message"> {localDisabledReason} <br /> </small> </span>)}
      </th>
    </tr>);
};

export default FormTitle;